<template>
	<div class="carousel">
		<template v-for="(item, index) in visibleData" :key="item.title">
			<div
				:ref="(el) => (itemRefs[index] = el)"
				v-if="index < 4"
				:class="[' animate__animated animate__faster carousel-item', getAnimationClass(index)]"
			>
				{{ item.title }}
			</div>
		</template>
	</div>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted, defineProps } from 'vue';

// const dataList = ref([]); // 存储所有数据
const visibleData = ref([]); // 当前显示的数据
// const animationClass = ref(''); // 动画class
const currentIndex = ref(0); // 当前显示的数据起始索引
const itemRefs = ref([]); // 存储每个数据项的 DOM 引用
const intervalId = ref(null); // 定时器

const props = defineProps({
	dataList: {
		type: Array,
		default: () => [],
	},
});
// 启动轮播功能
const startCarousel = () => {
	intervalId.value = setInterval(() => {
		console.log(currentIndex.value);

		// 动态更新可见数据
		// visibleData.value = dataList.value.slice(currentIndex.value, currentIndex.value + 3);
		if (props.dataList[currentIndex.value]) {
			visibleData.value.unshift(props.dataList[currentIndex.value]);
			// 获取 DOM 元素并重置动画

			if (itemRefs.value) {
				itemRefs.value.forEach((item, index) => {
					const animationClass = getAnimationClass(index);
					resetAnimation(item, animationClass);
				});
			}

			// 更新索引
			currentIndex.value++;
		}

		// 应用淡入动画
		// animationClass.value = 'animate__fadeIn';

		// 动画结束后移除动画class
		// setTimeout(() => {
		// 	animationClass.value = '';
		// }, 1000);
	}, 200);
};
// 重置并重新应用动画
const resetAnimation = (element, animationClass) => {
	element.classList.remove(animationClass); // 移除当前动画类
	// 重新应用动画类
	void element.offsetWidth; // 触发一次重绘，确保动画能再次生效
	element.classList.add(animationClass);
};
// 获取不同数据项的动画效果
const getAnimationClass = (index) => {
	if (index === 0) {
		return 'animate__fadeInDown'; // 第一条数据使用淡入效果
	} else if (index === 1) {
		return 'animate__slideInDown'; // 第二条数据向上滑动进入
	} else if (index === 2) {
		return 'animate__slideInDown'; // 第二条数据向上滑动进入
	} else {
		return 'animate__slideInDown'; // 第三条数据向下滑动进入
	}
};

// 监听 dataList 的变化，启动轮播
watch(
	() => props.dataList.length,
	() => {
		if (props.dataList.length) {
			if (intervalId.value == null) {
				startCarousel();
			}
		}
	},
	{
		immediate: true,
	}
);

// 模拟动态添加数据
onMounted(() => {});
onUnmounted(() => {
	if (intervalId.value) {
		console.log('取消');
		clearInterval(intervalId.value);
	}
});
</script>

<style scoped lang="scss">
.carousel {
	// display: flex;
	// flex-direction: column;
	max-height: 62px;
	// overflow: hidden;
}
.carousel-item {
	margin-bottom: 2px;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	max-width: 330px;
	padding-left: 16px;
	-webkit-animation-duration: .2s !important;
    animation-duration: .2s !important;
	&::before {
		content: '';
		position: absolute;
		left: 6px;
		top: 7px;
		background-color: var(--color-text-3);
		display: inline-block; // 此句为css样式展示重点
		width: 3px;
		height: 3px;
		border-radius: 50%;
		margin-right: 12px;
	}
}
</style>
